import React from "react";
import Avatar from "../common/Avatar";

function ChatListItem({
  id,
  active,
  name,
  avatar,
  lastMessage,
  lastMessageType,
  time,
  unreadCount = 0,
  online,
  isGroup = false,
  isTyping = false,
  onClick,
}) {

  const getPreview = () => {
    if (isTyping) return "typing...";
    if (lastMessageType === "image") return "🖼 Photo";
    if (lastMessageType === "video") return "🎥 Video";
    if (lastMessageType === "audio") return "🎤 Audio";
    if (lastMessageType === "file") return "📄 Document";
    return lastMessage || "No messages yet";
  };

  return (
    // <div
    //   className={`chat-list-item d-flex align-items-center px-3 py-2 ${active ? "active" : ""}`}
    //   onClick={onClick}
    //   style={{ cursor: "pointer", borderBottom: "1px solid #f0f0f0" }}
    // >

    //   {/* 🟢 Avatar */}
    //   <div className="position-relative">
    //     <Avatar
    //       src={avatar}
    //       name={name}
    //       online={!isGroup && online}
    //     />

    //     {!isGroup && online && (
    //       <span
    //         className="position-absolute bottom-0 end-0 p-1 bg-success border border-light rounded-circle"
    //         style={{ width: "12px", height: "12px" }}
    //       ></span>
    //     )}
    //   </div>

    //   <div className="ms-3 flex-grow-1 min-width-0">
    //     <div className="d-flex justify-content-between align-items-center mb-1">
    //       <h6
    //         className={`mb-0 text-truncate ${
    //           unreadCount > 0 ? "fw-bold" : "fw-normal"
    //         }`}
    //       >
    //         {name} {isGroup && <small className="text-muted">👥</small>}
    //       </h6>

    //       {time && (
    //         <small className="text-muted" style={{ fontSize: "11px" }}>
    //           {time}
    //         </small>
    //       )}
    //     </div>

    //     <div className="d-flex justify-content-between align-items-center">
    //       <small
    //         className={`text-truncate ${
    //           isTyping ? "text-primary fw-bold" : "text-muted"
    //         }`}
    //         style={{ maxWidth: "80%" }}
    //       >
    //         {getPreview()}
    //       </small>

    //       {unreadCount > 0 && !active && (
    //         <span
    //           className="badge bg-primary rounded-pill"
    //           style={{ fontSize: "10px" }}
    //         >
    //           {unreadCount}
    //         </span>
    //       )}
    //     </div>
    //   </div>
    // </div>

     <div
    className={`modern-chat-item ${active ? "active" : ""}`}
    onClick={onClick}
  >

    <div className="modern-chat-avatar-wrap">

      <Avatar
        src={avatar}
        name={name}
        online={!isGroup && online}
      />

      {!isGroup && online && (
        <span className="modern-online-dot"></span>
      )}
    </div>

    <div className="modern-chat-info">

      <div className="modern-chat-top">

        <h6>
          {name}

          {isGroup && (
            <span className="group-badge">
              👥
            </span>
          )}
        </h6>

        {time && (
          <span className="chat-time">
            {time}
          </span>
        )}
      </div>

      <div className="modern-chat-bottom">

        <p className={isTyping ? "typing-text" : ""}>
          {getPreview()}
        </p>

        {unreadCount > 0 && !active && (
          <div className="modern-unread-badge">
            {unreadCount}
          </div>
        )}
      </div>
    </div>
  </div>
  );
}

export default ChatListItem;